exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cy-text {\n  position: relative;\n}\n.cy-text__hover {\n  position: absolute;\n  background-color: #ccc;\n  color: #666;\n  font-size: 14px;\n  line-height: 1.4;\n  padding: 6px 10px;\n  border-radius: 5px;\n  border: 1px solid #eee;\n  max-width: 600px;\n  -webkit-transition: opacity 0.3s linear;\n  transition: opacity 0.3s linear;\n  z-index: -1;\n  opacity: 0;\n}\n.cy-text__hover.active {\n    z-index: 1999;\n    opacity: 1;\n}\n", ""]);

// exports
